import { useState } from "react";
import { Form } from "react-bootstrap";
import type { AccountCallbackFormValues } from "../types";

export interface AccountCallbackFormProps {
  id: string;
  initialValues: AccountCallbackFormValues;
  clientId: string;
  isSubmitting: boolean;
  onSubmit: (values: AccountCallbackFormValues) => void;
}

export const AccountCallbackForm = ({
  id,
  initialValues,
  clientId,
  isSubmitting,
  onSubmit,
}: AccountCallbackFormProps): JSX.Element => {
  const [redirectUri, setRedirectUri] = useState(initialValues.redirectUri);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;
    onSubmit({ redirectUri });
  };

  return (
    <Form id={id} data-testid={id} onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label htmlFor="account-callback-redirect-uri">
          Desired Callback URL
        </Form.Label>
        <Form.Control
          id="account-callback-redirect-uri"
          type="text"
          value={redirectUri}
          onChange={(e) => setRedirectUri(e.target.value)}
        />
        <Form.Text muted>
          This will be the redirect_uri for your OAuth2 authorizations.
        </Form.Text>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label htmlFor="account-callback-client-id">
          OAuth Client ID
        </Form.Label>
        <Form.Control
          id="account-callback-client-id"
          type="text"
          value={clientId}
          disabled
          readOnly
        />
      </Form.Group>
    </Form>
  );
};

export default AccountCallbackForm;
